"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const componentlibrary_1 = require("@emarketer/componentlibrary");
const UserRegistrationContext_1 = require("../../context/UserRegistrationContext");
const ExpandedCheckbox = ({ label, value, description, onClick, analytics, id, name }) => {
    const { userData } = (0, UserRegistrationContext_1.useUserRegistration)();
    const handleCallback = (val, checked) => {
        onClick(val, checked === componentlibrary_1.CHECKBOXCHECKED);
    };
    return (react_1.default.createElement(componentlibrary_1.AccordionCheckbox, { subscriber: false, checkboxLabel: label, checkboxProps: {
            value: value,
            callback: handleCallback,
            checked: userData?.newsletters?.includes(value) ? componentlibrary_1.CHECKBOXCHECKED : componentlibrary_1.CHECKBOXUNCHECKED,
            analytics: analytics,
            id: id,
            name: name,
        } }, description));
};
exports.default = ExpandedCheckbox;
